import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

/**
 * Typed Redux Hooks
 * 
 * Use these hooks instead of plain `useDispatch` and `useSelector`
 * for better TypeScript inference and autocomplete.
 * 
 * Usage:
 * ```tsx
 * const dispatch = useAppDispatch();
 * const user = useAppSelector(state => state.auth.user);
 * ```
 */

// Use throughout your app instead of plain `useDispatch`
export const useAppDispatch = () => useDispatch<AppDispatch>();

// Use throughout your app instead of plain `useSelector`
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
